import React, { useEffect, useReducer, useState } from 'react';
import {
  DialogComponent,
  Inputs,
  PhonesComponent,
  Spinner,
  UploaderComponent,
} from '../../../../../../../../../../Components';
import { useTranslation } from 'react-i18next';
import LookupAutocomplete from '../../../../../../../../../../Components/Controls/LookupAutocomplete/LookupAutocomplete';
import { ContactClassIdEnum } from '../../../../../../../../../../Enums';
import { StaticLookupsIds } from '../../../../../../../../../../assets/json/StaticLookupsIds';
import { CreateContactCorporate } from '../../../../../../../../../../Services';
import { showError } from '../../../../../../../../../../Helper';
import { useContactValidationContext } from '../../../../../../../../../../Contexts/ContactValidationContext/ContactValidationContext';
import { useSuccessDialog } from '../../../../../../../../../../SharedComponents';

const initialState = {
  classifications: [],
  country: {},
  city: {},
  landline: [],
  language: {},
  logoGUID: null,
  companyName: '',
  website: '',
};
const reducer = (state, { field, value }) => {
  if (field === 'reset') {
    return initialState;
  }
  return { ...state, [field]: value };
};
const AddCorporateContactDialog = ({
  open,
  onClose,
  parentTranslationPath,
}) => {
  const {
    data: { companyName, landline },
    resetStateHandler,
  } = useContactValidationContext();
  const { showDialog } = useSuccessDialog();
  const [isLoading, setIsLoading] = useState(false);
  const [state, dispatch] = useReducer(reducer, initialState);
  const { t } = useTranslation(parentTranslationPath);
  const saveHandler = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      const body = {
        classifications: state.classifications.map((e) => e.lookupItemId),
        countryId: state.country.lookupItemId,
        cityId: state.city.lookupItemId,
        landlineNumber: state.landline,
        languageId: state.language.lookupItemId,
        contactLogo: state.logoGUID
          ? {
              uuid: state.logoGUID,
              fileName: `${state.companyName}_${state.logoGUID}`,
            }
          : null,
        companyName: state.companyName,
        website: state.website,
      };
      const result = await CreateContactCorporate(body);
      showDialog(t('GlobalSuccessDialog:contact-successfully'), {
        name: result.companyName,
        id: result.contactId,
      });
      onCloseHandler();
    } catch (error) {
      showError('create_failed');
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    dispatch({ field: 'companyName', value: companyName });
    dispatch({ field: 'landline', value: [landline] });
  }, [companyName, landline]);

  function onCloseHandler() {
    onClose();
    resetStateHandler();
    dispatch({ field: 'reset' });
  }
  return (
    <DialogComponent
      isOpen={open}
      onCancelClicked={onCloseHandler}
      onCloseClicked={onCloseHandler}
      titleText={t('add_corporate_contact')}
      onSaveClicked={saveHandler}
      parentTranslationPath={parentTranslationPath}
      dialogContent={
        <div className='d-flex flex-wrap gap-12 fj-around pb-2'>
          <Spinner isActive={isLoading} isAbsolute />
          <Inputs
            labelValue={'company_name'}
            wrapperClasses={'w-25'}
            value={state.companyName}
            readOnly
            parentTranslationPath={parentTranslationPath}
          />
          <LookupAutocomplete
            lookupTypeId={StaticLookupsIds.Country}
            selectedValues={state.country}
            onChange={(_e, newValues) => {
              dispatch({ field: 'country', value: newValues });
              dispatch({ field: 'city', value: {} });
            }}
            label={'Country'}
            parentTranslationPath={parentTranslationPath}
          />
          <LookupAutocomplete
            lookupTypeId={StaticLookupsIds.Cities}
            selectedValues={state.city}
            onChange={(_e, newValues) => {
              dispatch({ field: 'city', value: newValues });
              if (
                newValues?.parentLookupTypeId !== state.country?.lookupItemId
              ) {
                dispatch({
                  field: 'country',
                  value: {
                    lookupItemId: newValues.parentLookupItemId,
                    lookupItemName: newValues.parentLookupItemName,
                  },
                });
              }
            }}
            lookupParentId={state.country?.lookupItemId}
            label={'City'}
            parentTranslationPath={parentTranslationPath}
          />
          <PhonesComponent
            value={state.landline[0]}
            isDisabled
            wrapperClasses={'w-25'}
            labelValue={'landline'}
          />
          <LookupAutocomplete
            lookupTypeId={StaticLookupsIds.Languages}
            selectedValues={state.language}
            onChange={(_e, newValues) =>
              dispatch({ field: 'language', value: newValues })
            }
            label={'language'}
            wrapperClasses={'w-25'}
            parentTranslationPath={parentTranslationPath}
          />
          <LookupAutocomplete
            lookupTypeId={ContactClassIdEnum.lookupTypeId}
            selectedValues={state.classifications[0]}
            onChange={(_e, newValues) =>
              dispatch({ field: 'classifications', value: [newValues] })
            }
            label={'contact_class'}
            parentTranslationPath={parentTranslationPath}
          />
          <Inputs
            labelValue={'website'}
            wrapperClasses={'w-75'}
            type={'url'}
            value={state.website}
            onInputChanged={(e) =>
              dispatch({ field: 'website', value: e.target.value })
            }
            parentTranslationPath={parentTranslationPath}
          />
          <UploaderComponent
            accept={'image/*'}
            wrapperClasses={'uploader-wrapper w-75'}
            labelValue={'logo'}
            uploadedChanged={(e) =>
              dispatch({ field: 'logoGUID', value: e?.[0]?.uuid })
            }
            parentTranslationPath={parentTranslationPath}
          />
        </div>
      }
    />
  );
};
export default AddCorporateContactDialog;
